export const WaybillIcon = ({ ...rest }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.00033 25.6666H21.0003C22.289 25.6666 23.3337 24.622 23.3337 23.3333V11.4665C23.3337 10.8476 23.0878 10.2542 22.6502 9.81656L15.8504 3.01673C15.4128 2.57914 14.8193 2.33331 14.2005 2.33331H7.00033C5.71166 2.33331 4.66699 3.37798 4.66699 4.66665V23.3333C4.66699 24.622 5.71166 25.6666 7.00033 25.6666Z"
        fill="white"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.167 2.91669V10.5H22.167"
        stroke="#0B0C0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 19.8333H17.4997"
        stroke="#0B0C0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 15.1667H17.4997"
        stroke="#0B0C0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 10.5H10.4997"
        stroke="#0B0C0E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="16.5"
        y="5.97852"
        width="11"
        height="11"
        rx="5.5"
        fill="#19AE57"
      />
      <path
        d="M19.5254 11.4785L21.1754 13.1285L24.4754 9.82849"
        stroke="white"
        strokeWidth="0.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
